module.exports = __webpack_public_path__ + "3b5f24a75c73bfd84b249c6dfe65c8a8.pdf";